<footer class="footer">
  <div class="footer-inner">
    <div class="footer-top">
      <section class="footer-col brand-col">
        <h2 class="brand-title">
          {{ texts.BRAND.TITLE }}
        </h2>

        <p class="brand-desc">
          {{ texts.BRAND.DESCRIPTION }}
        </p>

        <nav
          class="social-links"
          aria-label="Redes sociales de Argentus Mundo 3D"
        >
          <a
            [href]="ARGENTUS_CONTACT_INFO.INSTAGRAM_URL"
            class="social-icon"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram de Argentus Mundo 3D"
          >
            <img src="/assets/icons/instagram-logo.svg" alt="">
          </a>

          <a
            [href]="ARGENTUS_CONTACT_INFO.FACEBOOK_URL"
            class="social-icon"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook de Argentus Mundo 3D"
          >
            <img src="/assets/icons/facebook-logo.svg" alt="">
          </a>
        </nav>
      </section>

      <nav
        class="footer-col links-col"
        aria-label="Navegación del pie de página"
      >
        <h3 class="col-title">
          {{ texts.NAV.TITLE }}
        </h3>

        <ul class="nav-list">
          @for (item of navItems; track item.link) {
            <li>
              <a
                [routerLink]="item.link"
                (click)="onNavItemClick(item)"
              >
                {{ item.label }}
              </a>
            </li>
          }
        </ul>
      </nav>

      <section class="footer-col contact-col">
        <h3 class="col-title">Contacto</h3>

        <address class="contact-links">
          <a
            class="contact-link"
            [href]="'mailto:' + texts.CONTACT.EMAIL"
          >
            <span class="contact-label">Correo</span>
            <span>{{ texts.CONTACT.EMAIL }}</span>
          </a>

          <a
            class="contact-link"
            [href]="'tel:' + normalizedPhone"
          >
            <span class="contact-label">Teléfono</span>
            <span>{{ texts.CONTACT.PHONE }}</span>
          </a>

          <a
            class="contact-link"
            [href]="ARGENTUS_CONTACT_INFO.WHATSAPP_URL"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span class="contact-label">WhatsApp</span>
            <span>Escríbenos</span>
          </a>
        </address>
      </section>
    </div>

    <div class="footer-bottom">
      <p class="copyright">
        &copy; {{ currentYear }}. {{ texts.COPYRIGHT_SUFFIX }}
      </p>

      <nav class="legal-links" aria-label="Información legal">
        <a [routerLink]="['/terminos']">
          {{ texts.LEGAL.TERMS }}
        </a>

        <a [routerLink]="['/privacidad']">
          {{ texts.LEGAL.PRIVACY }}
        </a>
      </nav>
    </div>
  </div>
</footer>